import type { Optional } from '@festina-life/core'
import { zIndexStyles } from '@festina-life/ui/libs'
import { Icon } from '@festina-life/ui/structure'
import cx from 'classnames'

import { HoverEditButton } from './HoverEditButton'

export type EditMode = 'modal' | 'inline' | 'custom'

type Props = {
  isSimpleEditingAvailable: boolean
  onEdit: (mode: EditMode) => void
  disabled?: Optional<boolean>
}

export const HoverEditGroup = ({
  onEdit,
  isSimpleEditingAvailable,
  disabled = false,
}: Props) => (
  <div
    className={cx(
      `invisible absolute bottom-1 right-2 flex flex-row gap-x-2 ${zIndexStyles('bars')}`,
      {
        'group-hover/editor:visible': !disabled,
      },
    )}
  >
    {isSimpleEditingAvailable && (
      <HoverEditButton
        icon={<Icon name="Pencil" />}
        onClick={() => onEdit('custom')}
      />
    )}
    <HoverEditButton
      icon={<Icon name="CodeBracket" />}
      onClick={() => onEdit('inline')}
    />
    <HoverEditButton
      icon={<Icon name="ArrowTopRightOnSquare" />}
      onClick={() => onEdit('modal')}
    />
  </div>
)
